<template>
    <div v-if="proposal">
        <router-link v-if="proposal.project_id" :to="`/projects/${proposal.project_id}`" class="button is-default mb" >Back to Project</router-link>
        <div class="columns toolbar-box action-right">
            <div class="column is-12">
                <h1 class="title is-3 between-center"><span>{{ $route.params.slug }}</span></h1>
            </div>
            <div class="column is-12 action-box">
                <div class="field is-grouped is-grouped-right is-flex-wrap">
                    <p class="control">
                        <router-link :to="backlink({name: 'proposals.index'})" class="button is-default" >Back</router-link>
                    </p>
                    <p class="control">
                        <a :href="`/api/proposals/${proposal.id}/pdf`" @click.prevent="isPdfPreviewActive = true" download class="button is-info">Preview PDF</a>
                    </p>
                    <p class="control">
                        <a @click.prevent="isReminderModalActive = true" class="button is-info">Set Reminder</a>
                    </p>
                    <p  v-if="!proposal.project_id && !proposal.signature_log" class="control">
                        <a @click="openMessageModal({entity: proposal, entity_type: 'proposal', context: 'proposal-request-signature-message'})" class="button is-info">Send to Customer</a>
                    </p>
                    <p class="control">
                        <a v-if="!proposal.project_id" @click.prevent="handleConvert(proposal)" class="button is-success">Convert To Project</a>
                        <router-link v-else :to="`/projects/${proposal.project_id}`" class="button is-info">View Project</router-link>
                    </p>
                    <p class="control">
                        <a @click.prevent="handleRemove" class="button is-danger">Delete</a>
                    </p>
                    <p class="control" v-if="!proposal.signature_log
                        || (!proposal.signature_log.signed_by_client && !proposal.signature_log.signed_by_manager)">
                        <router-link v-if="proposal.id" :to="{ name: 'proposals.edit', params: { slug: proposal.id } }" class="button is-info">Edit</router-link>
                    </p>
                </div>
            </div>
        </div>
        <div class="columns">
            <div class="column is-4">
                <o-tabs type="is-boxed">
                    <o-tab-item :value="0" label="Summary">
                        <a class="panel-block between-center"><strong>Company:</strong> <span>{{ proposal.company.name }}</span></a>
                        <a class="panel-block between-center"><strong>Contact:</strong> <span>{{ proposal.contact_name }}</span></a>
                        <a class="panel-block between-center"><strong>Created By:</strong> <span>{{ userNameById(proposal.created_by) }}</span></a>
                        <a class="panel-block between-center"><strong>Borough:</strong> <span>{{ boroughNameById(proposal.borough) }}</span></a>
                        <a class="panel-block between-center"><strong>Address:</strong> <span>{{ proposal.address }}</span></a>
                        <a class="panel-block between-center"><strong>Status:</strong> <span>{{ statusNameById(proposal.status) }}</span></a>
                        <a class="panel-block between-center"><strong>Type of Project:</strong> <span>{{ projectTypeNameById(proposal.project_type) }}</span></a>
                        <a class="panel-block between-center"><strong>Created At:</strong> <span>{{ $filters.valueOrDefault($filters.datetime(proposal.created_at)) }}</span></a>
                        <a class="panel-block between-center"><strong>Sent At:</strong> <span>{{ $filters.valueOrDefault($filters.datetime(proposal.sent_at),'–') }}</span></a>
                        <a class="panel-block between-center"><strong>Lead Source:</strong> <span>{{ $filters.valueOrDefault(categoryNameById(proposal.lead_source_id)) }}</span></a>
                        <a class="panel-block between-center"><strong>Manager Signer:</strong> <span>{{ $filters.valueOrDefault(userNameById(proposal.user_signer_id)) }}</span></a>
                        <a class="panel-block between-center"><strong>Contact Signer:</strong> <span>{{ $filters.valueOrDefault(contactNameById(proposal.contact_signer_id)) }}</span></a>
                        <a v-if="proposal.lead_source_id === 2" class="panel-block between-center">
                            <strong>Lead Contact:</strong> <span>{{ $filters.valueOrDefault(contactNameById(proposal.lead_contact_id)) }}</span>
                        </a>
                        <a v-if="proposal.signature_log" class="panel-block between-center">
                          <strong>Contract sent at:
                          </strong> <span>{{ $filters.date(proposal.signature_log.created_at) }}</span>
                        </a>
                        <a v-if="proposal.signature_log" class="panel-block between-center">
                          <strong>Signed by Contact:
                          </strong> <span>{{ proposal.signature_log.signed_by_client ? 'Yes' : 'No' }}</span>
                        </a>
                        <a v-if="proposal.signature_log" class="panel-block between-center">
                          <strong>Signed by Manager:
                          </strong> <span>{{ proposal.signature_log.signed_by_manager ? 'Yes' : 'No' }}</span>
                        </a>
                    </o-tab-item>

                    <o-tab-item :value="1" label="Initial Services">
                        <o-tabs v-model="activeTab">
                            <o-tab-item :value="0" label="Main Services">
                                <a v-for="service in initialServices" :key="service.id" class="panel-block">{{ service.title }}</a>
                            </o-tab-item>
                            <o-tab-item :value="1" label="Sub-services">
                                <span v-for="(service, key) in initialServices" :key="key">
                                    <a v-for="workTypeId in service.work_types" :key="workTypeId" class="panel-block">
                                        {{ workTypeNameById(workTypeId) }}
                                    </a>
                                </span>
                            </o-tab-item>
                        </o-tabs >
                    </o-tab-item>
                    <o-tab-item :value="2" label="Optional Services">
                        <a v-for="service in optionalServices" :key="service.id" class="panel-block">{{ service.title }}</a>
                    </o-tab-item>
                </o-tabs >
            </div>
            <div class="column is-8 project-tabs">
                <o-tabs :model-value="activeTab" @update:model-value="changeTab" type="is-boxed is-hd-wide project-tabs">
                    <o-tab-item :value="0" label="Milestones"></o-tab-item>
                    <o-tab-item :value="1" label="Emails"></o-tab-item>
                    <o-tab-item :value="2" label="Notes"></o-tab-item>
                    <o-tab-item :value="3" label="Files"></o-tab-item>
                </o-tabs >

                <router-view @tab-changed="changeRoute" />
            </div>
        </div>

       <o-modal :can-cancel="['escape', 'outside', 'button']" scroll="keep" v-model:active="isReminderModalActive" has-modal-card>
            <reminder-modal :reference-id="proposal.id" reference-type="proposal"/>
        </o-modal>

       <o-modal :can-cancel="['escape', 'outside', 'button']" scroll="keep" v-model:active="isPdfPreviewActive" has-modal-card :width="960" >
            <preview-modal :file="previewFile" />
        </o-modal>
    </div>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex'
import Table from '../../mixins/Table'
import ChangeRemindBy from './../../components/modals/ChangeRemindBy'
import PreviewModal from './../../components/modals/Preview'
import HasBacklink from './../../mixins/Backlink'

    export default {
        mixins: [Table, HasBacklink],

        components: { PreviewModal },

        beforeMount () {
          this.fetchProposalById(this.$route.params.slug)
              .then(res => {
                this.openInitialTab()
                this.validateRemindBy(res.data.data)
                this.proposal = res.data.data
                return res
              })
        },

        computed: {
            ...mapGetters([
                'projectOptionalServicesBySource',
                'projectInitialServicesBySource',
                'categoryNameById',
                'workTypeNameById',
                'boroughNameById',
                'companyNameById',
                'contactNameById',
                'projectTypeNameById',
                'proposalById',
                'userNameById',
                'currentUserId',
            ]),

            proposalId() {
                return parseInt(this.$route.params.slug)
            },

            proposal() {
                return this.proposalById(this.proposalId)
            },

            initialServices() {
                return this.projectInitialServicesBySource({
                    source_id: this.proposalId,
                    source_type: 'proposal'
                })
            },

            optionalServices() {
                return this.projectOptionalServicesBySource({
                    source_id: this.proposalId,
                    source_type: 'proposal'
                })
            },

            previewFile() {
                let proposal = this.proposal

                const port = window.location.port ? `:${window.location.port}` : '';
                return {
                    name: `Proposal #${proposal.number}`,
                    mime: 'application/pdf',
                    path: `${window.location.protocol}//${window.location.hostname}${port}/proposals/${proposal.id}/pdf`,
                    generatedOnTheFly: true
                }
            }
        },

        data () {
            return {
                isReminderModalActive: false,
                isPdfPreviewActive: false,
                activeTab: 0,
                moment,
                proposal: null
            }
        },

      mounted() {
        // this.fetchProjectServices()
      },

      methods: {
            ...mapActions([
                'fetchProposalById',
                'openMessageModal',
                'convertProposal',
                'removeProposal',
                'updateProposal',
                'fetchProjectServices'
            ]),

            handleConvert() {
                this.convertProposal(this.proposal)
                    .then(res => {
                        this.successMessage('Proposal was successfully converted to a project')
                        return res
                    })
            },

            handleRemove() {
                this.confirmMessage(
                    'Are you sure?',
                    'This action cannot be undone.',
                    'Yes'
                ).then(() => {
                    this.removeProposal(this.proposal)
                        .then(res => {
                            this.$router.push('/proposals')
                            return res
                        })
                })
            },
            changeTab(tabIndex) {
                let subRouteName = ''

                switch (tabIndex) {
                    case 0:
                        subRouteName = 'milestones'
                        break
                    case 1:
                        subRouteName = 'emails'
                        break
                    case 2:
                        subRouteName = 'notes'
                        break
                    case 3:
                        subRouteName = 'files'
                        break
                }

                this.$router.push({ name: `proposals.show.${subRouteName}` })
            },

            changeRoute(route) {
                if (typeof route === 'string') {
                    return this.openInitialTab(route)
                }

                this.$router.push(route)
                this.openInitialTab(route.name)
            },

            openInitialTab(routeName = null) {
                switch (routeName || this.$route.name) {
                    case 'proposals.show.milestones':
                        this.activeTab = 0
                        break
                    case 'proposals.show.emails':
                        this.activeTab = 1
                        break
                    case 'proposals.show.notes':
                        this.activeTab = 2
                        break
                    case 'proposals.show.files':
                        this.activeTab = 3
                        break
                }
            },
            validateRemindBy(proposal) {
                if((proposal.status === 1 || proposal.status === 26) &&
                   proposal.sent_at &&
                   proposal.created_by === this.currentUserId &&
                   proposal.remind_by &&
                   moment(proposal.remind_by).isSameOrBefore(moment())) {
                    this.customMessage
                        ('Proposal',
                            `Proposal ${proposal.number} is not signed, do you want to send E-mail notification to Client?`,
                            [
                                { text: 'Close' },
                                { text: 'Postpone' },
                                { text: 'Send Mail' }
                            ])
                            .then((e) => {
                                    switch(e.button) {
                                        case 0:
                                            break
                                        case 1:
                                            this.openModalComponent(ChangeRemindBy, { entity: proposal, entity_type: 'proposal' })
                                            break
                                        case 2:
                                            this.openMessageModal({ entity: proposal, entity_type: 'proposal', context: 'proposal-remind-message' })
                                            break
                                    }
                                })
                    }
            }
        }
    }
</script>
